import { render, staticRenderFns } from "./Joukkueet.vue?vue&type=template&id=ae1b2474&scoped=true"
import script from "./Joukkueet.vue?vue&type=script&lang=js"
export * from "./Joukkueet.vue?vue&type=script&lang=js"
import style0 from "./Joukkueet.vue?vue&type=style&index=0&id=ae1b2474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae1b2474",
  null
  
)

export default component.exports